/* eslint-disable no-console */
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { inject } from 'alfa';
import { withRouter } from 'react-router-dom';

import { LoadingBlock } from '../loading';

const shouldLoad = (userToLoad) => userToLoad.requiresLogin();

const UserLoader = (props) => {
  console.debug('[SESSION: User loader]');
  const { user } = props;
  const [loading, setLoading] = useState(shouldLoad(user));

  const loadUser = useCallback(async () => {
    try {
      await user.ping();
    } catch (error) {
      console.error('ERROR: UserLoader: user.ping()', error);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    if (!shouldLoad(user)) {
      return;
    }

    console.debug('[SESSION: Loading user]');
    loadUser();
  }, [loadUser, user]);

  if (loading) {
    return <LoadingBlock />;
  }

  return props.children;
};

UserLoader.propTypes = {
  children: PropTypes.any,
  user: PropTypes.shape({
    ping: PropTypes.func,
  }),
};

export default inject(withRouter(UserLoader), ['user']);
